import React from 'react'
import { useLabels } from 'src/pages/AccountSettings/AccountSettings.hooks'
import { FilterName, FilterParam } from '../../FilterBar.types'
import { NONE_VALUE } from '../../FilterBar.constants'
import { FilterDropdown } from '../FilterDropdown'

export const DashboardLabelFilterDropdown = React.memo(
  ({ isNested = false }: { isNested?: boolean }): JSX.Element => {
    const { data, isLoading, error } = useLabels()
    if (error) return <></>
    const labels = data?.getItemsList() || []
    const filterValues = [
      NONE_VALUE,
      ...labels.map((label) => ({
        value: label.getName(),
        label: label.getName(),
      })),
    ]

    return (
      <FilterDropdown
        filterParam={FilterParam.DASHBOARD_LABEL}
        filterName={FilterName.DASHBOARD_LABEL}
        filterValues={filterValues}
        isLoading={!data || isLoading}
        isNested={isNested}
      />
    )
  },
)
